export default __webpack_public_path__ + "static/withanubis-30ccfc007c342ea8396a15c5d34fe6c5.png";